/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { authForgotPassword } from '../../axios/authForgotPassword'
import type {
	AuthForgotPasswordError,
	AuthForgotPasswordRequest,
	AuthForgotPasswordResponse,
} from '../../types/AuthForgotPassword'

export const authForgotPasswordMutationKey = () => [{ url: '/auth/forgot-password' }] as const

export type AuthForgotPasswordMutationKey = ReturnType<typeof authForgotPasswordMutationKey>

export type AuthForgotPasswordVariables = {
	data: AuthForgotPasswordRequest
}

/** @see backend/nexus/modules/Authentication/Http/Controllers/AuthController.php AuthController::forgotPassword */
export function useAuthForgotPassword<TContext = unknown>(
	options?: UseMutationOptions<
		AuthForgotPasswordResponse,
		AxiosError<AuthForgotPasswordError>,
		AuthForgotPasswordVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: authForgotPasswordMutationKey(),
		mutationFn: ({ data }: AuthForgotPasswordVariables) => authForgotPassword(data, config).then(res => res.data),
		...options,
	})
}
